import { Link } from "react-router-dom";
import {
  ChevronRight,
  Flag,
  Gift,
  RefreshCw,
  ScrollText,
  Shield,
  Trophy,
  Users,
} from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { Card } from "@/components/ui/Card";
import { ROLE_LABEL } from "./shared";

const SHORTCUTS = [
  {
    to: "/admin/usuarios",
    icon: Users,
    title: "Usuários",
    caption: "Contas, papéis, saldo e créditos",
  },
  {
    to: "/admin/torneios",
    icon: Flag,
    title: "Torneios",
    caption: "Potes, apostas e liquidação",
  },
  {
    to: "/admin/resultados",
    icon: Trophy,
    title: "Resultados",
    caption: "Vencedores e liquidações por torneio",
  },
  {
    to: "/admin/extrato",
    icon: ScrollText,
    title: "Extrato Geral",
    caption: "Todas as movimentações financeiras",
  },
  {
    to: "/admin/boas-vindas",
    icon: Gift,
    title: "Boas-vindas",
    caption: "Créditos automáticos para novos cadastros",
  },
  {
    to: "/admin/sincronizacao",
    icon: RefreshCw,
    title: "Sincronização",
    caption: "Status do sync SportsDataIO",
  },
] as const;

export default function AdminHubPage() {
  const { user } = useAuth();
  if (!user) return null;

  return (
    <div className="flex flex-col gap-4 px-5 pt-6">
      <div className="flex items-center gap-3">
        <div className="flex h-11 w-11 items-center justify-center rounded-full bg-secondary">
          <Shield size={20} className="text-tint" />
        </div>
        <div>
          <h1 className="text-xl font-bold">Admin</h1>
          <p className="text-xs text-muted-foreground">
            {user.name} · {ROLE_LABEL[user.role]}
          </p>
        </div>
      </div>

      <div className="flex flex-col gap-3">
        {SHORTCUTS.map(({ to, icon: Icon, title, caption }) => (
          <Link key={to} to={to}>
            <Card className="flex items-center gap-4 p-4 transition-colors hover:border-tint/40">
              <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-(--radius-field) bg-secondary">
                <Icon size={18} className="text-tint" />
              </div>
              <div className="min-w-0 flex-1">
                <p className="text-sm font-bold">{title}</p>
                <p className="truncate text-xs text-muted-foreground">
                  {caption}
                </p>
              </div>
              <ChevronRight size={18} className="text-muted-foreground" />
            </Card>
          </Link>
        ))}
      </div>
    </div>
  );
}
